export var AI_CHAT_CREATE_BILLS_KEY = 'aichat:create:bills:cache';
